import Typewriter from 'typewriter-effect';
import { Link } from 'react-router-dom';

const HomePage = ({isLoggedIn})=>{
    console.log(isLoggedIn)
    return (
        <section className="hero video is-fullheight-with-navbar">
            <div className="hero-body">
                <div className="container has-text-centered">
                    <p class="title is-size-1" style={{"filter":"drop-shadow(0 0 0.2rem grey)"}}>
                    <Typewriter
                        options={{
                        strings: ['Hello!', 'Welcome to the Diary App!', 'Spill Some Secrets Here ...'],
                        autoStart: true,
                        loop: true,
                    }}/></p>
                    { !isLoggedIn ?
                    <><Link className="px-4 py-4 mx-4	my-4 button is-primary  " to="/signup" style={{"filter":"drop-shadow(1px 1px 0.3rem grey)"}}><strong>Sign up</strong></Link>
                    <Link className="px-4 py-4 mx-4	my-4 button" to="/login" style={{"filter":"drop-shadow(1px 1px 0.3rem grey)"}}>
                        <span class="icon is-small">
                            <i class="fas fa-sign-in-alt"></i>
                        </span>
                        <span>Log in</span>
                    </Link></>
                    :
                    <Link className="button is-primary" to="/createnote" style={{"filter":"drop-shadow(1px 1px 0.3rem grey)"}}>
                        <span class="icon is-small">
                            <i class="fas fa-feather"></i>
                        </span>
                        <span><strong>Write Diary</strong></span>
                    </Link>
                    }
                </div>
            </div>
        </section>
    )
}

export default HomePage